import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";
import { isValidElement } from "react";
import { CustomButton, ViewColumnsButton } from "@/shared/components";
import Stack from "@mui/material/Stack";

export interface CustomToolbarProps {
  downloadButton?: any;
  createButton?: any;
  refetchButton?: any;
  viewColumnsButton?: any;
  headButtons?: React.ReactNode;
}

export const CustomToolbar: React.FC<CustomToolbarProps> = ({
  downloadButton,
  createButton,
  refetchButton,
  viewColumnsButton,
  headButtons,
}) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {headButtons}
      {viewColumnsButton && <ViewColumnsButton {...viewColumnsButton} />}
      {downloadButton && (
        <CustomButton icon={DownloadIcon} text="Download" {...downloadButton} />
      )}
      {refetchButton && (
        <CustomButton icon={RefreshIcon} text="Refetch" {...refetchButton} />
      )}
      {/* createButton — либо готовый элемент, либо набор пропсов для CustomButton */}
      {isValidElement(createButton)
        ? createButton
        : createButton && (
            <CustomButton icon={AddIcon} text="Create" {...createButton} />
          )}
    </Stack>
  );
};
